"use strict";
import Barba from "barba.js";
import Env from "../base/env.js";
import Channels from "../base/channels";
import gsap from "gsap";
import ParallaxFx from "../fx/ParallaxFxVert";
import RevealFx from "../fx/RevealFx";
import Accordion from "accordion-js";

let page;

class Page {
  constructor(view = "") {
    this.view = view;
    this.classView = "currentView--milleMusic";
    // Launch Fn
    this.funcLaunch = this.intro.bind(this);
    if (Env.framework.UI.launcher.LAUNCHED == false) this.channels();
  }

  channels() {
    Channels.on("launcher::exit", this.funcLaunch);
  }

  destroy() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
  }

  finalize() {
    setTimeout(() => {
      if (Env.isVisiting === true) {
        this.intro();
      }
    }, Env.introBaseDelay);

    this.accordion = new Accordion(
      this.view.querySelector(".accordion-container"),
      {
        showMultiple: true,
      }
    );
    this.fx();
  }

  fx() {
    const $parallaxes = this.view.querySelectorAll(".jsParallaxY--view");

    for (let $para of $parallaxes) {
      const instance = new ParallaxFx($para);
      instance.animate();
    }
    const instance = new ParallaxFx(
      this.view.querySelector(".jsParallax--logo")
    );
    instance.animate();

    new RevealFx(this.view);
  }

  intro() {
    const $elementsA = [
      this.view.querySelectorAll(".jsIntroA"),
      this.view.querySelectorAll(".compo-type-a .fx"),
      this.view.querySelectorAll(".compo-type-a .visuals"),
    ];
    const $elementsB = [this.view.querySelectorAll(".jsIntroB")];
    const tl = gsap.timeline();

    tl.add([
      gsap.fromTo(
        $elementsA,
        { autoAlpha: 0, y: 10 },
        { autoAlpha: 1, y: 0, ease: "cubic.out", duration: 1, stagger: 0.2 }
      ),
      gsap.fromTo(
        $elementsB,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: "cubic.out", duration: 1, stagger: 0.2 }
      ),
    ]);
  }
}

page = Barba.BaseView.extend({
  namespace: "milleMusic",
  node: undefined,
  onEnter: function () {
    this.node = new Page(this.container);
    Env.$html.classList.add(this.node.classView);
  },
  onEnterCompleted: function () {
    this.node.finalize();
  },
  onLeave: function () {
    this.node.destroy();
  },
  onLeaveCompleted: function () {
    if (this.container.getAttribute("data-namespace") != this.namespace) {
      Env.$html.classList.remove(this.node.classView);
    }
  },
});

export default page;
